import React from 'react'
import "./snowEffect.scss"

export default function SnowEffect() {
  return (
    <>
        <div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
<div className="snow"></div>
    </>
  )
}
